$(function() {
  'use strict';
  const BaseModule = require('_base/base');

  class FoldableModule extends BaseModule {
    preInit() {
      this.isMother = true;
      this.CLASS_EQUALIZE = 'js__equalize';
    }

    postInit() {
      const initialFlex = ['flex-grow', 'flex-shrink', 'flex-basis']
        .map(prop => this.$el.css(prop))
        .join(' ');

      this.initialFlex = initialFlex || 1;
      this.renderFlex = 'initial';
    }

    preReset() {
      var module = this;

      module.$el.css({
        flex: module.initialFlex,
        'max-height': 'none',
      });
    }

    postCalculate() {
      var module = this;

      if (!module.subModules.length) return

      if (module.$el.hasClass(this.CLASS_EQUALIZE)) {
        var maxHeight = module.subModules[0].calculatedHeight;
        module.subModules.slice(1).forEach(function(subModule) {
          if (maxHeight > subModule.calculatedHeight) {
            maxHeight = subModule.calculatedHeight;
          }
        });

        module.subModules.forEach(function(subModule) {
          if (subModule.setHeight) subModule.setHeight(maxHeight);
        });

        module.renderFlex = maxHeight;
      }
    }

    postRender() {
      var module = this;

      module.$el.css({
        flex: module.renderFlex,
        'max-height': module.renderFlex,
      });
    }
  }

  $('.js__foldable').each(function() {
    new FoldableModule($(this));
  });
});
